module.exports = __webpack_public_path__ + "static/media/CSPORT MONAURAL POWER AMPLIFIER 212PAM2.f012f962.png";